import { classnames } from '@bem-react/classnames'
import type { ComponentProps, PropsWithChildren } from 'react'
import { memo } from 'react'

import css from './ModalRight.css'

type ModalRightProps = ComponentProps<'div'>

export const ModalRight = memo<PropsWithChildren<ModalRightProps>>(function ModalRight({
  children,
  className = '',
  ...rest
}) {
  return (
    <div className={classnames(css.right, className)} {...rest}>
      {children}
    </div>
  )
})
